import { render, staticRenderFns } from "./StatusDot.vue?vue&type=template&id=287f29c7&"
import script from "./StatusDot.vue?vue&type=script&lang=js&"
export * from "./StatusDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports